import { RESOURCE_ORDER } from '../Game/definitions.js'

export default class EngineerView
{
    constructor(_options)
    {
        this.factory = _options.factory
        this.container = this.factory.createNecromancer()
        this.container.position.set(0, 8, 0)
        this.container.rotation.z = Math.PI
        this.walkPhase = 0
        this.actionPhase = 0
    }

    syncInventory(_inventory)
    {
        const anchor = this.container.userData.inventory
        for(const child of [...anchor.children])
        {
            child.traverse((_child) =>
            {
                if(_child.isMesh)
                    _child.geometry.dispose()
            })
            anchor.remove(child)
        }
        let index = 0
        for(const resource of RESOURCE_ORDER)
        {
            for(let count = 0; count < _inventory[resource]; count++)
            {
                const item = this.factory.createItem(resource, 0.82)
                item.position.set((index % 2 - 0.5) * 0.28, 0, Math.floor(index / 2) * 0.16)
                item.rotation.z = (index % 2 ? 1 : -1) * 0.12
                anchor.add(item)
                index++
            }
        }
    }

    update(_delta, _moving, _action)
    {
        const parts = this.container.userData
        this.walkPhase += _delta * (_moving ? 10 : 3)
        this.actionPhase += _delta
        const walk = _moving ? Math.sin(this.walkPhase) : 0
        parts.body.position.z = _moving ? Math.abs(Math.sin(this.walkPhase)) * 0.06 : 0
        parts.arms[0].rotation.x = - walk * 0.25
        if(_action?.type === 'channel')
        {
            parts.arms[1].rotation.x = -1.5 + Math.sin(this.actionPhase * 7) * 0.12
            parts.arms[0].rotation.x = -0.8
            parts.head.rotation.x = -0.12
            parts.staff.rotation.z = Math.sin(this.actionPhase * 5) * 0.08
        }
        else
        {
            parts.arms[1].rotation.x = walk * 0.25
            parts.head.rotation.x = 0
            parts.staff.rotation.z = 0
        }
    }
}
